import { AxiosError, AxiosResponse } from 'axios'
import { useMutation, useQueryClient } from 'react-query'
import { uploadStickerAPI } from '../../api/sticker'
import { Sticker, PackageInfo } from '../../types'
import { processAnExpiredSession } from '../../utils/errorHandling'
import { toFormData } from '../../utils/uploadPackageInfoUtils'
import * as Sentry from '@sentry/react'

import { PACKAGE_INFO_KEY } from './usePackage'
type UploadStickerProp = {
  userId: string
  packageId: string
  sessionToken: string
  fileList: FileList
}
type UploadStickerFormData = {
  userId: string
  packageId: string
  sessionToken: string
  fileList: File
}

export const UPLOAD_STICKER_KEY = 'upload-sticker'
const stickerUpload = async ({
  userId,
  packageId,
  sessionToken,
  fileList,
}: UploadStickerProp) => {
  const promises: Promise<AxiosResponse<any, any>>[] = []

  for (const file of fileList) {
    const formData = toFormData<UploadStickerFormData>({
      userId,
      packageId,
      sessionToken,
      fileList: file,
    })

    promises.push(uploadStickerAPI(formData))
  }
  const results = await Promise.allSettled(promises)
  const addedStickerList: Sticker[] = []
  const errorList: any[] = []

  results.forEach((result: any) => {
    console.log('rrr', result)
    if (result.status === 'fulfilled') {
      const stickerValue = result.value[0].value as any
      // 결과 예예시
      //   ACL: {*: {…}, M7wjPwq216: {…}, role:admin: {…}}
      // count: 0
      // createdAt: "2022-02-28T05:52:29.107Z"
      // objectId: "dxM8i02511"
      // origin: {__type: 'File', name: 'emoticons/origin/332254bcf8_dxM8i02511.gif', url: 'https://d2etihmuil288v.cloudfront.net/emoticons/origin/332254bcf8_dxM8i02511.gif'}
      // package: {__type: 'Pointer', className: 'EmoticonPackage', objectId: '3SZFZHFOti'}
      // priority: 0
      // updatedAt: "2022-02-28T05:52:29.412Z"
      const uploadedSticker: Sticker = {
        objectId: stickerValue.objectId,
        createdAt: stickerValue.createdAt,
        updatedAt: stickerValue.updatedAt,
        origin: stickerValue.origin.url,
        w408: null,
        categories: null,
        category: null,
        categoryText: null,
        textLang: null,
        emojiCategories: null,
        emojiTexts: null,
        w300: null,
        imageOptimizedPolicy: null,
      }
      addedStickerList.push(uploadedSticker)
    } else {
      errorList.push(result)
      //some erro
    }
  })
  if (errorList.length > 0) {
    throw Error(errorList[0])
  }
  addedStickerList.sort((a, b) => {
    if (a.createdAt > b.createdAt) {
      return -1
    }
    if (a.createdAt < b.createdAt) {
      return 1
    }
    return 0
  })
  return addedStickerList
}
export const useUploadSticker = (packageId: string) => {
  const queryClient = useQueryClient()
  return useMutation(
    ({ userId, packageId, sessionToken, fileList }: UploadStickerProp) =>
      stickerUpload({
        userId,
        packageId,
        sessionToken,
        fileList,
      }),
    {
      onSuccess: async (stickerList) => {
        const prePackageInfo = queryClient.getQueryData<PackageInfo>([
          PACKAGE_INFO_KEY,
          packageId,
        ])
        if (prePackageInfo && prePackageInfo.emoticons) {
          const newPackageInfo: PackageInfo = {
            ...prePackageInfo,
            emoticons: [...stickerList, ...prePackageInfo.emoticons],
          }
          console.log(stickerList)
          console.log('newPackageInfo', newPackageInfo)
          queryClient.setQueryData(
            [PACKAGE_INFO_KEY, packageId],
            newPackageInfo,
          )
        }
      },
      onError: (e: AxiosError) => {
        console.dir(e)
        switch (e.response?.status) {
          case 403:
            processAnExpiredSession()
            break
          default:
            Sentry.captureException(
              new Error(
                `upload sticker pkgid:${packageId} message ::` + e.message,
              ),
            )
        }
      },
      mutationKey: packageId,
    },
  )
}
